import { render, staticRenderFns } from "./PersonalProfileModal.vue?vue&type=template&id=2c63b1ef&scoped=true&"
import script from "./PersonalProfileModal.vue?vue&type=script&lang=js&"
export * from "./PersonalProfileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c63b1ef",
  null
  
)

export default component.exports